import axios from "axios";
import {
  requestInterceptor,
  responseData,
  responseError
} from "./interceptors";
export const HTTP_BASE_API =
  window.location.protocol + "//" + window.shield.ShieldConfig.host;
export const IS_PROD_ENV = process.env.NODE_ENV === "production";

axios.interceptors.request.use(requestInterceptor, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use(responseData, responseError);

export default {
  axios,
  baseConfig: {
    baseURL: IS_PROD_ENV ? HTTP_BASE_API : "",
    timeout: 7000,
    // method: "POST",
    headers: {
      "Content-Type": "application/json"
    }
  }
};
